module.exports = function() {
  return new Worker("https://app.groovehq.com/2021-04-02-11-51-08-7084b0860/" + "chat-sw.js");
};